// extracted by mini-css-extract-plugin
export default {"container":"KC-z","dimension":"LC-z","dimensionLabels":"MC-z"};